import { LabelMode } from "./../../../../utils/label-mode.enum";
import { CommonModule } from "@angular/common";
import { Component, inject, OnInit, signal } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { UserService } from "src/app/services/api/user.service";
import { SweetAlertService } from "src/app/services/sweet-alert-service/sweet-alert.service";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { AuthService } from "../../auth";
import { MonitorService } from "src/app/services/api/monitor.service";
import { forkJoin, lastValueFrom, Observable } from "rxjs";
import {
  ParentingInteraction,
  UnderParenting,
} from "src/app/services/model/under-parenting.model";
import { Clipboard } from "@angular/cdk/clipboard";
import { Role } from "src/utils/enum/role.enum";
import { ParentInteractionType } from "src/utils/enum/under-parenting.enum";
import { SetError } from "src/utils/set-error.validator";

@Component({
  selector: "app-user-parent",
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: "./user-parent.component.html",
  styleUrl: "./user-parent.component.scss",
})
export class UserParentComponent implements OnInit {
  #fb = inject(FormBuilder);
  #authService = inject(AuthService);
  #translate = inject(TranslateService);
  #monitorService = inject(MonitorService);
  #swalService = inject(SweetAlertService);
  #toastService = inject(ToastService);
  #clipboard = inject(Clipboard);

  currentUser = this.#authService.currentUser()!.user;
  fileUrl = environment.apiFileUrl;

  underParenting = signal<UnderParenting[]>([]);

  isLoading = signal(true);
  tableLoading = signal(true);
  firstInitLoading = signal(true);
  isCopied = signal<boolean>(false);
  isStudent = signal<boolean>(this.currentUser.role.id === 2);

  linkIcon = signal<string>("fasten");

  form: FormGroup;
  LabelMode = LabelMode;
  error: any;

  Role = Role;

  ngOnInit(): void {
    this.buildForm();
    this.fetchData();
  }
  _setLoading(value: boolean, time: number = 500) {
    setTimeout(() => {
      this.isLoading.update((_) => value);
    }, time);
  }

  buildForm() {
    this.form = this.#fb.group({
      code_invitation: [null, Validators.required],
      // days: 30,
      // course_id: [null],
      // page: [1],
      // datatable: [true],
    });

    // this.form
    //   .get("course_id")
    //   ?.valueChanges.pipe(debounceTime(200))
    //   .subscribe((val) => {
    //     this.fetchData();
    //   });
  }

  async fetchData() {
    const params = this.form.getRawValue();
    this.isLoading.update(() => true);

    // The invitation code is the student's own; a parent never asks for it.
    const serviceArray = [
      this.#monitorService.getUnderParenting() as Observable<any>,
      ...(this.isStudent()
        ? [this.#monitorService.getCodeInvitation() as Observable<any>]
        : []),
    ];
    forkJoin(serviceArray).subscribe({
      next: ([under_parenting, code_invitation]) => {
        this.underParenting.update(() => under_parenting);
        if (code_invitation) {
          this.form.patchValue({ code_invitation: code_invitation.data });
        }
      },
      error: (error) => {},
      complete: () => {
        this.tableLoading.update((_) => false);
        this.firstInitLoading.update(() => false);
        this._setLoading(false);
      },
    });
  }

  copyClipboard() {
    this.#clipboard.copy(this.form.value.code_invitation);
    this.isCopied.update(() => true);
    this.#toastService.toastInfo(this.#translate.instant("APP.COPY_INVITED"));
    setTimeout(() => {
      this.isCopied.update(() => false);
    }, 2000);
  }

  async addStudent() {
    this.error = {};
    if (this.form.invalid) {
      this.error = SetError(this.form);
      return;
    }
    const code = this.form.value.code_invitation;
    const payload = {
      code,
      parent_interaction_type_id: ParentInteractionType.PARENTING_ID,
    };

    try {
      const addStudent = await lastValueFrom(
        this.#monitorService.addStudentUnderParenting(payload)
      );
      this.#toastService.toastSuccess(
        this.#translate.instant("APP.ADD_STUDENT_SUCCESS")
      );
      this.form.reset();
    } catch (error: any) {
      let error_message = this.#translate.instant("APP.ADD_STUDENT_FAILED");
      if (error.error.error === "Invalid code.") {
        error_message = this.#translate.instant("APP.INVALID_CODE");
      }
      this.#toastService.toastError(error_message);
    }
  }

  async unlinkStudent(item: UnderParenting) {
    this.onLeave();
    await this.#swalService.swalConfirmation();
    const payload: ParentingInteraction = {
      parent_interaction_type_id: ParentInteractionType.CANCEl_ID,
      student_id: item.student_id,
    };
    try {
      const unlinkService = await await lastValueFrom(
        this.#monitorService.unlinkStudent(payload)
      );
      this.#toastService.toastSuccess(
        this.#translate.instant("APP.DISCONNECTED")
      );
    } catch (error: any) {
      let error_message = error.error.error;

      this.#toastService.toastError(error_message);
    }
  }

  onHover() {
    this.linkIcon.update(() => "disconnect");
  }
  onLeave() {
    this.linkIcon.update(() => "fasten");
  }
}
